export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10393.b8e0f17d.jpg";